import GuideVideoPage from "./GuideVideoPage"

export default GuideVideoPage